import { getInDomain } from '../domains/externalUtils';

export function productTierIsAdSupported(state) {
  return getInDomain('payments.selectors.productTierIsAdSupported', false)(state);
}

export function productTierIsPlus(state) {
  return getInDomain('payments.selectors.productTierIsPlus', false)(state);
}

export function productTierIsPremium(state) {
  return getInDomain('payments.selectors.productTierIsPremium', false)(state);
}

export function hasPremiumPlan(state) {
  return getInDomain('payments.selectors.hasPremiumPlan', false)(state);
}

export function getSelectedTier(state) {
  return getInDomain('payments.selectors.getSelectedTier', '')(state);
}

export function getSelectedDiscountType(state) {
  return getInDomain('payments.selectors.getSelectedDiscountType', '')(state);
}

export function getSelectedPlanName(state) {
  return getInDomain('payments.selectors.getSelectedPlanName', '')(state);
}

export function getSpecialOfferTier(state) {
  return getInDomain('payments.selectors.getSpecialOfferTier', '')(state);
}

export function getSpecialOfferPlanName(state) {
  return getInDomain('payments.selectors.getSpecialOfferPlanName', '')(state);
}

export function isInSpecialOfferFlow(state) {
  return getInDomain('payments.selectors.isInSpecialOfferFlow', false)(state);
}

export function getSpecialOfferCode(state) {
  return getInDomain('payments.selectors.getSpecialOfferCode', '')(state);
}

export function getSpecialOfferCampaignId(state) {
  return getInDomain('payments.selectors.getSpecialOfferCampaignId', null)(state);
}

export function getAuthCampaignCopy(state) {
  return getInDomain('payments.selectors.getAuthCampaignCopy', '')(state);
}

export function isInFamilyPlanInviteeFlow(state) {
  return getInDomain('payments.selectors.isInFamilyPlanInviteeFlow', false)(state);
}

export function getIsPendingPurchase(state) {
  return getInDomain('payments.selectors.getIsPendingPurchase', false)(state);
}

export function isTrialEligible(state) {
  return getInDomain('payments.selectors.isTrialEligible', false)(state);
}

export function isPremiumTrialEligible(state) {
  return getInDomain('payments.selectors.isPremiumTrialEligible', false)(state);
}

export function getActiveProductGroupTier(state) {
  return getInDomain('payments.selectors.getActiveProductGroupTier', '')(state);
}

export function getActiveProductDiscountType(state) {
  return getInDomain('payments.selectors.getActiveProductDiscountType', '')(state);
}

export function getActiveProductType(state) {
  return getInDomain('payments.selectors.getActiveProductType', '')(state);
}

export function getPaymentProvider(state) {
  return getInDomain('payments.selectors.getPaymentProvider', '')(state);
}

export function isPartnerBilled(state) {
  return getInDomain('payments.selectors.isPartnerBilled', false)(state);
}

export function isActiveProductSpecialOffer(state) {
  return getInDomain('payments.selectors.isActiveProductSpecialOffer', false)(state);
}

export function getPendingProductPrice(state) {
  return getInDomain('payments.selectors.getPendingProductPrice', '')(state);
}

export function getPaymentBackedTrialLength(state, tier) {
  return getInDomain('payments.selectors.getPaymentBackedTrialLength', null)(state, tier);
}

export function isInvitingFamilyPlanAccounts(state) {
  return getInDomain('payments.selectors.isInvitingFamilyPlanAccounts', false)(state);
}

export function getInPaymentBackedTrial(state) {
  return getInDomain('payments.selectors.getInPaymentBackedTrial', false)(state);
}

export function getCurrentProductTier(state) {
  return getInDomain('payments.selectors.getCurrentProductTier', '')(state);
}

export function getCurrentProductPrice(state) {
  return getInDomain('payments.selectors.getCurrentProductPrice', '')(state);
}

export function getActiveProductDurationType(state) {
  return getInDomain('payments.selectors.getActiveProductDurationType', '')(state);
}

export function getActiveProductDurationTime(state) {
  return getInDomain('payments.selectors.getActiveProductDurationTime', '')(state);
}

export function getActiveProductTimesRenewable(state) {
  return getInDomain('payments.selectors.getActiveProductTimesRenewable', null)(state);
}

export function getActiveProductPrice(state) {
  return getInDomain('payments.selectors.getActiveProductPrice', '')(state);
}

export function getSubscriptionPrice(state) {
  return getInDomain('payments.selectors.getSubscriptionPrice', '')(state);
}

export function getSubscriptionDurationType(state) {
  return getInDomain('payments.selectors.getSubscriptionDurationType', '')(state);
}

export function getSubscriptionDurationTime(state) {
  return getInDomain('payments.selectors.getSubscriptionDurationTime', '')(state);
}

export function isPartnerUpgradeFlow(state) {
  return getInDomain('payments.selectors.isPartnerUpgradeFlow', false)(state);
}

export function getPartnerUpgradePartnerName(state) {
  return getInDomain('payments.selectors.getPartnerUpgradePartnerName', '')(state);
}

export function getPartnerUpgradeTier(state) {
  return getInDomain('payments.selectors.getPartnerUpgradeTier', '')(state);
}

export function getPartnerUpgradePlanName(state) {
  return getInDomain('payments.selectors.getPartnerUpgradePlanName', '')(state);
}

export function hasSelectedPlan(state) {
  return getInDomain('payments.selectors.hasSelectedPlan', false)(state);
}

export function isProcessingPaypalToken(state) {
  return getInDomain('payments.selectors.isProcessingPaypalToken', false)(state);
}

export function hasUserDowngraded(state) {
  return getInDomain('payments.selectors.hasUserDowngraded', false)(state);
}

export function didChangePlans(state) {
  return getInDomain('payments.selectors.didChangePlans', false)(state);
}

export function getPreviousTier(state) {
  return getInDomain('payments.selectors.getPreviousTier', false)(state);
}

export function getPreviousDiscountType(state) {
  return getInDomain('payments.selectors.getPreviousDiscountType', false)(state);
}

export function isActiveProductDiscountTypeStudent(state) {
  return getInDomain('payments.selectors.isActiveProductDiscountTypeStudent', false)(state);
}
